import React from 'react';
import moment from 'moment';
import { DATE_SHORTCUTS } from '@utils/constants';
import { calcShortcutInterval, granularity } from '@utils';

const getDateShortcuts = (liveMode) => {
  let last15MShortcut: any = [];

  const shortcuts = [
    // [DATE_SHORTCUTS.last1Hour, calcShortcutInterval(DATE_SHORTCUTS.last1Hour)],
    [DATE_SHORTCUTS.last2Hours, calcShortcutInterval(DATE_SHORTCUTS.last2Hours)],
    [DATE_SHORTCUTS.last6Hours, calcShortcutInterval(DATE_SHORTCUTS.last6Hours)],
    [DATE_SHORTCUTS.past24Hours, calcShortcutInterval(DATE_SHORTCUTS.past24Hours)],
    [DATE_SHORTCUTS.today, calcShortcutInterval(DATE_SHORTCUTS.today)],
    [DATE_SHORTCUTS.yesterday, calcShortcutInterval(DATE_SHORTCUTS.yesterday)],
    [DATE_SHORTCUTS.past7Days, calcShortcutInterval(DATE_SHORTCUTS.past7Days)],
    [DATE_SHORTCUTS.lastWeek, calcShortcutInterval(DATE_SHORTCUTS.lastWeek)],
    [DATE_SHORTCUTS.thisMonth, calcShortcutInterval(DATE_SHORTCUTS.thisMonth)],
    [DATE_SHORTCUTS.lastMonth, calcShortcutInterval(DATE_SHORTCUTS.lastMonth)],
    [DATE_SHORTCUTS.past30Days, calcShortcutInterval(DATE_SHORTCUTS.past30Days)],
    [DATE_SHORTCUTS.past90Days, calcShortcutInterval(DATE_SHORTCUTS.past90Days)],
    [DATE_SHORTCUTS.past1Year, calcShortcutInterval(DATE_SHORTCUTS.past1Year)],
  ];

  if (liveMode) {
    last15MShortcut = [[DATE_SHORTCUTS.last15Mins, calcShortcutInterval(DATE_SHORTCUTS.last15Mins)]];
  }

  return [...last15MShortcut, ...shortcuts];
};

/**
 * withDefaultOptions
 * This provides default options -> DisabledDate and shortcut dates
 */
const withDefaultOptions = (Wrapper) => {
  class WithDefaultOptionsHOC extends React.PureComponent {
    getDisabledDate = () => (current) => {
      const { durationAllowed }: any = this.props;
      return current.isAfter(moment(), 'day') || current.isBefore(moment()
        .subtract(durationAllowed, 'month'), 'day');
    };

    getTimeGranularity = (from, to) => {
      const g = granularity(from, to, true);
      switch (g) {
        case 'PT1M': return 5;
        case 'PT1H': return 60;
        default: return null;
      }
    }

    render() {
      const { innerRef, liveMode, ...rest }: any = this.props;
      const shortcuts = getDateShortcuts(liveMode);

      return (
        <Wrapper
          disabledDate={this.getDisabledDate()}
          shortcuts={shortcuts}
          granularity={this.getTimeGranularity}
          ref={innerRef}
          {...rest}
        />
      );
    }
  }

  WithDefaultOptionsHOC.defaultProps = {
    innerRef: React.createRef(),
    durationAllowed: 13, // months
  };
  return WithDefaultOptionsHOC;
};

export default withDefaultOptions;
